import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onActivated, onMounted, ref } from 'vue';
import { getContact, getHasCard, getListAdd, getProduct, getWechatSDKSign } from '@/api/miscellaneous';
import userStoreModule from '@/store/modules/user';
import { useRoute, useRouter } from 'vue-router';
import { getIsFollow } from '@/api/miscellaneous';
import moment from 'moment/moment';
import { calcDistance } from '@/libs/utils';
import { listSubscribe, turnPages } from '@/hooks';
import { ImagePreview, Toast } from 'vant';
import CityTreeSelector from '@/components/CityTreeSelector.vue';
import VarietiesTreeSelector from '@/components/CityTreeSelector.vue';
import VipTag from '@/components/VipTag.vue';
import ListItemAd from '@/components/ListItemAd.vue';
import SearchCategorie from '@/components/SearchCategorie.vue';
import { format } from '@/libs/utils';
import RestrictDialog from '@/components/RestrictDialog.vue';
import config from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'WantToBuy',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();

const { subscribe, isSubscribe } = listSubscribe();

const getListData = ref({
    lat: 0,
    lon: 0,
    areaId: '',
    keyword: (route.query.keyword || '') as string,
    categoryId: '',
    specifications: '',
    sort: '',
});
const isNotFollow = ref(false);
const tel = ref(false);
const curlId = ref('');
const isShowTel = ref(false);
const restrictShow = ref(false);
const restrictCode = ref('');
const lineHeightArr = ref<any[]>([]);
const {
    list,
    loadMore: getList,
    loading,
    finished,
    refresh,
} = turnPages({
    api: getProduct,
    params: getListData,
    loadingReturn: true,
});

const addList = ref<any[]>([]);
const areaMenu = ref<any>(null);
const categoryMenu = ref<any>(null);
const isShowSearch = ref(false);

const filterCategoryName = ref('品种');

const isRealName = ref(false);
const IsBaojia = ref(false);
onMounted(() => {
    getListData.value.lat = userStoreModule.userDetail.location?.lat || 0;
    getListData.value.lon = userStoreModule.userDetail.location?.lon || 0;
    // const {categoryId, categoryName, keyword} = route.query;
    // if (categoryId) {
    //     getListData.value.categoryId = categoryId as string;
    //     getListData.value.keyword = (keyword as string) || '';
    //     filterCategoryName.value = categoryName as string;
    // }
    getAdd();
    share();
    isFollow();
});

onActivated(() => {
    const { categoryId, categoryName } = route.query;
    if (categoryId) {
        list.value = [];
        getListData.value.categoryId = categoryId as string;
        getListData.value.keyword = (categoryName as string) || '';
        filterCategoryName.value = categoryName as string;
        getAdd();
        refresh();
    }
    router.replace({ name: 'WantToBuy', query: {} });
});

const getAdd = () => {
    getListAdd({ keywords: '广告位用勿动处理求购供应列表中' }).then((res: any) => {
        addList.value = JSON.parse(res.contentJson);
        getList();
    });
};

const share = () => {
    getWechatSDKSign({ url: location.href.split('#')[0] }).then(res => {
        //const {appId, timestamp, nonceStr, signature} = res;
        wx.updateTimelineShareData({
            title: '苗搭档-求购列表', // 分享标题
            link: `${config.webHost}/WantToBuy`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: 'https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/h5/seek_logo_new.png', // 分享图标
            success: function () {
                // 设置成功
            },
        });
        wx.updateAppMessageShareData({
            title: '苗搭档-求购列表', // 分享标题
            desc: '【海量求购】良心推荐，优质求购信息，大人速来批阅！', // 分享描述
            link: `${config.webHost}/WantToBuy`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: 'https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/h5/seek_logo_new.png', // 分享图标
            success: function () {
                // 设置成功
            },
        });
    });
};
const junmp = (url: string) => {
    window.location.href = url;
};
const test = (e: HTMLElement) => {
    if (!e) return;
    nextTick(() => {
        const { offsetHeight } = e,
            line = Math.ceil(offsetHeight / Number(getComputedStyle(e).lineHeight.replace('px', '')));
        lineHeightArr.value.push({ line, showClosing: line > 2 });
    });
};
const classes = (idx: number) => {
    return {
        overflow: lineHeightArr.value[idx]?.showClosing,
    };
};
const show = (idx: number) => {
    lineHeightArr.value[idx].showClosing = !lineHeightArr.value[idx].showClosing;
};
const call = (id: string): void => {

    curlId.value=id;

    getHasCard().then(res => {
        isRealName.value = !res;
        if (!res) {
            isRealName.value = true;
            return;
        } else {
            getContact({ id })
                .then(res => {
                    tel.value = res;
                    isShowTel.value = true;
                })
                .catch(e => {
                    console.log(e,'-----')
                    let { code } = e;
                    if ([104, 105].includes(code)) {
                        restrictCode.value = code;
                        restrictShow.value = true;
                    }
                    else if (code == 779) {
                        IsBaojia.value = true;
                    }
                });
        }
    });

};

const setAreaId = (id: string) => {
    refresh({ areaId: id });
    areaMenu.value.toggle();
};

const setCategoryId = (id: string, name: string) => {
    filterCategoryName.value = name;
    refresh({ categoryId: id });
    categoryMenu.value.toggle(false);
};

const setSort = () => {
    getListData.value.sort = getListData.value.sort ? '' : 'distance';
    refresh();
};

const isFollow = () => {
    const userId = userStoreModule.userDetail.user.id;
    getIsFollow(userId).then((res: any) => {
        isNotFollow.value = !res.subscripte;
    });
};
const timeToNow = (time: number) => {
    let cycle = 60 * 1000 * 60 * 24 * 7;
    let ttt = (new Date().getTime() - time) % cycle;
    return moment(new Date().getTime() - ttt).fromNow();
};

const distance = (point: { lat: number; lon: number }) => {
    if (userStoreModule.userDetail.location) {
        let { lat, lon } = userStoreModule.userDetail.location;
        const dis = calcDistance({ lat: point.lat, lng: point.lon }, { lat, lng: lon });
        return dis > 1000 ? (dis / 1000).toFixed(2) + 'km' : dis.toFixed(2) + 'm';
    } else {
        return '';
    }
};

const showImg = (img: string[], idx = 0) => {
    ImagePreview({
        images: img,
        startPosition: idx,
    });
};

const similarPurchase = (id: string) => {
    getListData.value.categoryId = id;
};

const toQuotedPrice = (id: string) => {
    getHasCard().then(res => {
        isRealName.value = !res;
        if (!res) {
            isRealName.value = true;
            return;
        } else {
            router.push({ name: "QuotedPrice", query: { id: id } });
        }
    });
}
const cancelRealName = () => {
    isRealName.value = false;
}

const gotoRealName = () => {
    isRealName.value = false;
    router.push({ name: 'RealName', query: { id: curlId.value, detailType: 'wanttoby', back: 'true' } });
}

const cancelBaoJia = () => {
    IsBaojia.value = false;
}

const gotoBaoJia = (id:string) => {
    console.log(id);
    IsBaojia.value = false;
    router.push({ name: 'QuotedPrice', query: { id: curlId.value, detailType: 'wanttoby', back: 'true' } });

}

const __returned__ = { route, router, subscribe, isSubscribe, getListData, isNotFollow, tel, curlId, isShowTel, restrictShow, restrictCode, lineHeightArr, list, getList, loading, finished, refresh, addList, areaMenu, categoryMenu, isShowSearch, filterCategoryName, isRealName, IsBaojia, getAdd, share, junmp, test, classes, show, call, setAreaId, setCategoryId, setSort, isFollow, timeToNow, distance, showImg, similarPurchase, toQuotedPrice, cancelRealName, gotoRealName, cancelBaoJia, gotoBaoJia, nextTick, onActivated, onMounted, ref, getContact, getHasCard, getListAdd, getProduct, getWechatSDKSign, userStoreModule, useRoute, useRouter, getIsFollow, moment, calcDistance, listSubscribe, turnPages, ImagePreview, Toast, CityTreeSelector, VarietiesTreeSelector, VipTag, ListItemAd, SearchCategorie, format, RestrictDialog, config }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})